export async function loadScript(url: string, callback?: () => Record<string, any>): Promise<void> {
  const script = document.createElement('script');
  script.src = url;
  script.type = 'module';
  script.dataset.sourceMap = url + '.map';
  if (callback) script.onload = callback;
  document.head.appendChild(script);
}

export async function loadCookieGatedScript(url: string): Promise<void> {
  const functionalCookieCategory = '3';

  if (window.OneTrust?.InsertScript) {
    window.OneTrust.InsertScript(url, 'head', null, null, functionalCookieCategory);
    return;
  }

  const timeout = setTimeout(() => {
    if (!window.OneTrust) {
      loadCookieGatedScriptFallback(url);
    }
    clearInterval(interval);
  }, 10000);

  const interval = setInterval(() => {
    if (window.OneTrust?.InsertScript) {
      window.OneTrust.InsertScript(url, 'head', null, null, '3');
      clearTimeout(timeout);
      clearInterval(interval);
    }
  }, 100);
}

function loadCookieGatedScriptFallback(url: string): void {
  const script = document.createElement('script');
  script.src = url;
  script.className = 'optanon-category-3';
  script.type = 'module';
  document.head.appendChild(script);
}

export async function loadScriptMap(mapUrl: string): Promise<void> {
  const script = document.querySelector(`script[src="${mapUrl}"]`) as HTMLScriptElement;
  if (script?.dataset?.sourceMap) {
    script.dataset.sourceMap = mapUrl;
  }
}

export async function loadCss(url: string): Promise<void> {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = url;
  link.dataset.sourceMap = url + '.map';
  document.head.appendChild(link);
}

export async function loadBrandAssets(
  resources: Resources,
  brandAssetsManifest: Manifest,
  bucketPath: string
) {
  if (brandAssetsManifest === undefined) {
    throw new Error('LiveChat Error: Brand Asset Manifest is missing');
  }

  for (const key in resources) {
    const keyTyped = key as ResourceKey;
    if (resources[keyTyped].enabled) {
      await loadBrandAsset(keyTyped, brandAssetsManifest, bucketPath);
    }
  }
}

export async function loadBrandAsset(
  resourceKey: ResourceKey,
  brandAssetsManifest: Manifest,
  bucketPath: string
) {
  if (resourceKey === undefined) {
    throw new Error('Assets are missing from the manifest: ');
  }

  const r = brandAssetsManifest[resourceKey];

  if (!r) return;

  for (const assetPath of r) {
    const url = `${bucketPath}${assetPath}`;
    if (assetPath.endsWith('.js')) {
      await loadCookieGatedScript(url);
      if (assetPath.endsWith('.map')) {
        const mapUrl = url + '.map';
        await loadScriptMap(mapUrl);
      }
    } else if (assetPath.endsWith('.css')) {
      await loadCss(url);
    }
  }
}

export async function loadLivePersonAssets(
  resourceArray: string[] | undefined,
  bucketPath: string
) {
  if (resourceArray === undefined) {
    throw new Error('Assets are missing from the manifest: ');
  }
  for (const assetPath of resourceArray) {
    const url = `${bucketPath}${assetPath}`;
    if (assetPath.endsWith('.js')) {
      await loadCookieGatedScript(url);
      if (assetPath.endsWith('.map')) {
        const mapUrl = url + '.map';
        await loadScriptMap(mapUrl);
      }
    } else if (assetPath.endsWith('.css')) {
      await loadCss(url);
    }
  }
}

export async function loadCookieGatedCoreAssets(resourceArray: string[], bucketPath: string) {
  // Ignores Asset Loader, fires health check when done
  if (resourceArray === undefined) {
    throw new Error('Core Assets are missing from the manifest: ');
  }
  const coreAssetpath = resourceArray.filter((assetPath) => !assetPath.includes('asset-loader'));

  for (const assetPath of coreAssetpath) {
    const url = `${bucketPath}${assetPath}`;
    if (assetPath.endsWith('.js')) {
      await loadScript(url);
      if (assetPath.endsWith('.map')) {
        const mapUrl = url + '.map';
        await loadScriptMap(mapUrl);
      }
    }
  }
}

export async function loadChatUiAssets(resourceArray: string[], bucketPath: string) {
  if (resourceArray === undefined) {
    throw new Error('Chat UI Assets are missing from the manifest: ');
  }
  for (const assetPath of resourceArray) {
    const url = `${bucketPath}${assetPath}`;
    if (assetPath.endsWith('.js')) {
      await loadScript(url);
      if (assetPath.endsWith('.map')) {
        const mapUrl = url + '.map';
        await loadScriptMap(mapUrl);
      }
    } else if (assetPath.endsWith('.css')) {
      await loadCss(url);
    }
  }
}
